import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Progress,
  Col,
} from "reactstrap";

import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import "../../assets/css/test.css";

import { Link } from "react-router-dom";
import CreditMappingModel from "models/creditMapping.model";
import Loader from "components/loader/Loader";

const CreditMapping = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };
  const [totalpage, setTotalpage] = useState();
  const [status, setStatus] = useState("?class_status=All");
  const[dueclass,setDueClass]=useState("");
  const [completedclass, setCompleteclass] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    try {
      let result;
  
      if (status && dueclass && completedclass) {
        // Call API with three filters
        result = await CreditMappingModel.ListWithThreeFilters(
          status,
          dueclass,
          completedclass,
          parameters
        );
      } else if (status && dueclass) {
        // Call API with two filters (status and dueclass)
        result = await CreditMappingModel.ListWithTwoFilters(
          status,
          dueclass,
          parameters
        );
      } else if (status && completedclass) {
        // Call API with two filters (status and completedclass)
        result = await CreditMappingModel.ListWithTwoFilters(
          status,
          completedclass,
          parameters
        );
      } else {
        // Call API with only the status
        result = await CreditMappingModel.List(status, parameters);
      }
  
      if (result) {
       
        setDataList(result);
        setTotalpage(result?.meta?.total_page)
        setCurrentPage(result?.meta?.current_page);
        setPerPage(result?.meta?.per_page);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
     
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getListData();
  }, [currentPage]);
  const[alldata,setAlldata]=useState();
  const[activedata,setActivedata]=useState();
  const[holddata,setHolddata]=useState();
  const[completeddata,setCompleteddata]=useState();
  const[discontinuddata,setDiscontinueddata]=useState();
  const[smedata,setSmedata]=useState();
  const[combineddata,setcombineddata]=useState();
  const[sepratedata,setSepratedata]=useState();


  const getListDatacount = async () => {
    await CreditMappingModel.List("?class_status=All")
      .then((result) => {
        if (result) {
          setAlldata(result?.data?.length);
        }
      })
      .catch((error) => {
        
      });
    await CreditMappingModel.List("&class_status=Active")
      .then((result) => {
        if (result) {
          setActivedata(result?.data?.length);
        }
      })
      .catch((error) => {
       
      });
    await CreditMappingModel.List("&class_status=Hold")
      .then((result) => {
        if (result) {
          setHolddata(result?.data?.length);
        }
      })
      .catch((error) => {
       
      });
    await CreditMappingModel.List("&class_status=Completed")
      .then((result) => {
        if (result) {
          setCompleteddata(result?.data?.length);
        }
      })
      .catch((error) => {
        
      });
    await CreditMappingModel.List("&class_status=Discontinued")
      .then((result) => {
        if (result) {
          setDiscontinueddata(result?.data?.length);
        }
      })
      .catch((error) => {
        
      });
    await CreditMappingModel.List("&class_type=SME")
      .then((result) => {
        if (result) {
          setSmedata(result?.data?.length);
        }
      })
      .catch((error) => {
       
      });
    await CreditMappingModel.List("&class_type=COMBINED")
      .then((result) => {
        if (result) {
          setcombineddata(result?.data?.length);
        }
      })
      .catch((error) => {
        
      });
    await CreditMappingModel.List("&class_type=SEPARATE")
      .then((result) => {
        if (result) {
          setSepratedata(result?.data?.length);
        }
      })
      .catch((error) => {
        
      });
  };
  useEffect(() => {
    getListData();
    getListDatacount();
   
  }, [location]);
  useEffect(() => {
    getListData();
  }, [status,dueclass,completedclass]);

  /*  const handleDel = async (delId) => {
     helper.sweetalert
       .confirm("Are you sure you want to delete this Message", "info", true)
       .then((result) => {
         if (result.isConfirmed) {
           contact_usModel.delete(delId).then((res) => {
             helper.sweetalert.toast(res.data?.message);
             getListData();
           });
         }
       });
   }; */
  

  return (
    <>
      <div className="pt-7 px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <Container style={{ marginTop: "20px" }}>
                <Row
                  className="mb-1"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Col
                    md={7}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      border: "1px solid black",
                    }}
                  >
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: status == "?class_status=All" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=All");
                      }}
                    >
                      <span>All</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=All" ? "black" : "blue",
                          }}
                        >
                          {" "}
                         {alldata} {" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Active" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Active");
                      }}
                    >
                      <span>Active</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Active"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {" "}
                          {activedata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Hold" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Hold");
                      }}
                    >
                      <span>Hold</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Hold" ? "black" : "blue",
                          }}
                        >
                          {" "}
                          {holddata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Completed"
                            ? "blue"
                            : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Completed");
                      }}
                    >
                      <span>Completed</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Completed"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {" "}
                          {completeddata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Discontinued"
                            ? "blue"
                            : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Discontinued");
                      }}
                    >
                      <span>Discontinued</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_status=Discontinued"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {" "}
                          {discontinuddata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                  </Col>
                  <Col md={1}></Col>
                  <Col
                    md={4}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      border: "1px solid black",
                    }}
                  >
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: status == "?class_type=SME" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=SME");
                      }}
                    >
                      <span>SME</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "??class_type=SME" ? "black" : "blue",
                          }}
                        >
                          {" "}
                          {smedata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_type=COMBINED" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=COMBINED");
                      }}
                    >
                      <span>Combined</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_type=COMBINED"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {" "}
                          {combineddata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_type=SEPARATE" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=SEPARATE");
                      }}
                    >
                      <span>Separate</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        (
                        <span
                          style={{
                            color:
                              status == "?class_type=SEPARATE"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {" "}
                          {sepratedata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                  </Col>
                </Row>
              </Container>
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Credit Mapping List</h3>
                <div className="d-flex">
                  <div className="mr-4">
                    <span className="mr-1">Due Classes</span>
                    <input type="checkbox" value="&getDueClasses=true" onChange={(e)=>{
                      setDueClass(e.target.checked ? e.target.value : "")}}
                      />
                  </div>
                  <div>
                    <span className="mr-1">Completed Classes</span>
                    <select className="rounded px-1" onChange={(e)=>{
                      setCompleteclass(e.target.value)
                    }}>
                      <option value="">Select</option>
                      <option value="&class_percentage_from=1&class_percentage_to=10">01-10%</option>
                      <option value="&class_percentage_from=11&class_percentage_to=20">11-20%</option>
                      <option value="&class_percentage_from=21&class_percentage_to=30">21-30%</option>
                      <option value="&class_percentage_from=31&class_percentage_to=40">31-40%</option>
                      <option value="&class_percentage_from=41&class_percentage_to=50">41-50%</option>
                      <option value="&class_percentage_from=51&class_percentage_to=60">51-60%</option>
                      <option value="&class_percentage_from=61&class_percentage_to=70">61-70%</option>
                      <option value="&class_percentage_from=71&class_percentage_to=80">71-80%</option>
                      <option value="&class_percentage_from=81&class_percentage_to=90">81-90%</option>
                      <option value="&class_percentage_from=91&class_percentage_to=100">91-100%</option>
                    </select>
                  </div>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">SN.</th>
                    <th scope="col">Class Name</th>
                    <th scope="col">Student </th>
                    <th scope="col">Tutors </th>
                    <th scope="col">Fee Status</th>
                    <th scope="col">Type</th>
                    <th scope="col">Status</th>
                    <th scope="col">Last Payment Date</th>

                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={9} className="text-center align-middle py-4">
                        Please wait...
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {dataList?.data?.map((dataItem, itemIndex) => {
                        console.log("data", dataItem);
                        const percentage = dataItem?.price_parent
                          ? ((dataItem?.price_parent -
                              (dataItem?.total_paid || 0)) /
                              dataItem?.price_parent) *
                            100
                          : 0;

                        return (
                          <tr key={`creditList${itemIndex}`}>
                            <td style={{ padding: "0.3rem" }}>
                              {itemIndex + 1}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {dataItem?.name}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <b>Students : </b>
                              {dataItem?.studentData?.map(
                                (student, studentIndex) => {
                                  return (
                                    <span
                                      key={`${itemIndex}student${studentIndex}`}
                                    >
                                      {studentIndex > 0 ? ", " : ""}
                                      {student?.name}
                                    </span>
                                  );
                                }
                              )}
                              <br />
                              <b>Client : </b>
                              {dataItem?.parentData?.first_name}{" "}
                              {dataItem?.parentData?.last_name}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {dataItem?.tutorData?.first_name}{" "}
                              {dataItem?.tutorData?.last_name}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              <Progress
                                className="my-2"
                                value={percentage}
                                style={{ height: "25px" }}
                              >
                                {`${Math.round(percentage)}%`}
                              </Progress>
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {dataItem?.mode}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {dataItem?.status}
                            </td>
                            <td style={{ padding: "0.3rem" }}>
                              {dataItem?.lastPayment}
                            </td>
                            <td
                              className="p-0 pt-1"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                padding: "0.3",

                                alignItems: "center",
                              }}
                            >
                              <UncontrolledTooltip
                                placement="bottom"
                                target="eyeTooltip"
                              >
                                View
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  marginTop: "8px",
                                  display: "inline-block",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="eyeTooltip"
                                to={`/admin/creditmapping/creditmapping-view/${dataItem?.id}/${dataItem?.lastClassCycle?.id}`}
                              >
                                <i className="fa-solid fa-eye"></i>
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {!isLoading && (
                  <TablePagination
                  totalPages={totalpage}
                  currentPage={currentPage}
                    pageUrl="/admin/creditmapping?"
                  />
                )}
              </CardFooter>
            </Card>
          </div>
        </Row>
      </div>
    </>
  );
};

export default CreditMapping;
